import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Laptop01 = function Laptop01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M3 16V7.2c0-1.1201 0-1.6802.218-2.108a2 2 0 0 1 .874-.874C4.5198 4 5.08 4 6.2 4h11.6c1.1201 0 1.6802 0 2.108.218.3763.1917.6823.4977.874.874C21 5.5198 21 6.08 21 7.2V16h-5.3373c-.2445 0-.3668 0-.4819.0276a1 1 0 0 0-.2891.1198c-.1009.0618-.1874.1483-.3603.3212l-.0628.0628c-.1729.1729-.2594.2594-.3603.3212a1 1 0 0 1-.2891.1198C13.7041 17 13.5818 17 13.3373 17h-2.6746c-.2445 0-.3668 0-.4819-.0276a1 1 0 0 1-.289-.1198c-.101-.0618-.1875-.1483-.3604-.3212l-.0628-.0628c-.173-.1729-.2594-.2594-.3603-.3212a1 1 0 0 0-.289-.1198C8.704 16 8.5817 16 8.3372 16zm0 0c-.5523 0-1 .4477-1 1v.3333c0 .62 0 .93.0682 1.1843a2 2 0 0 0 1.4142 1.4143C3.7367 20 4.0467 20 4.6667 20h14.6666c.62 0 .93 0 1.1843-.0681a2 2 0 0 0 1.4143-1.4143C22 18.2633 22 17.9533 22 17.3333c0-.31 0-.465-.0341-.5921a1 1 0 0 0-.7071-.7071C21.1317 16 20.9767 16 20.6667 16H20"
    })
  }));
};
export default Laptop01;